import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";


export const MeteringRecordsLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListMeteringRecords') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetMeteringRecord') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/metering-records'/>
                    )
                }
            />
        </Routes>
    );
};
